import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded in EAKC-MVP: src/lib/integrations/{types,index,github,jira}.ts,
// src/lib/jobs/sync-worker.ts, docs/content/10 + diagrams/integration-providers.md.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "GitHub, Jira, Confluence, Slack — and the sync worker calls one method. It never knows which source it's talking to." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 5.5, caption: "Every connector wants its own auth, its own pagination, its own content format." },
  { scene: "problem", fromSec: 6.2, holdSec: 5, caption: "Wire that into the pipeline four times and you've built four pipelines." },
  { scene: "problem", fromSec: 11.5, holdSec: 4.5, caption: "The fix isn't a smarter pipeline — it's a contract every source agrees to." },
];

export const INTERFACE: ScriptLine[] = [
  { scene: "interface", fromSec: 0.4, holdSec: 6, caption: "types.ts: one IntegrationProvider interface. A type string, testConnection, fetchDocuments." },
  { scene: "interface", fromSec: 6.5, holdSec: 6, caption: "That's the whole surface. Behind it, each provider hides 270 to 335 lines of API quirks." },
  { scene: "interface", fromSec: 13, holdSec: 4.5, caption: "The pipeline only ever sees these three methods." },
];

export const REGISTRY: ScriptLine[] = [
  { scene: "registry", fromSec: 0.4, holdSec: 6, caption: "index.ts maps a provider-type string to a singleton instance — a plain object literal." },
  { scene: "registry", fromSec: 6.5, holdSec: 6, caption: "getProvider('jira') returns the Jira class as an IntegrationProvider. No switch statement, no if-else." },
];

export const WORKER: ScriptLine[] = [
  { scene: "worker", fromSec: 0.4, holdSec: 6, caption: "The sync worker reads provider_type from the row, calls getProvider, then fetchDocuments." },
  { scene: "worker", fromSec: 6.5, holdSec: 6.5, caption: "From here on it's provider-agnostic: chunk, embed, SHA-dedup, store — identical for all of them." },
];

export const SHAPES: ScriptLine[] = [
  { scene: "shapes", fromSec: 0.4, holdSec: 5.5, caption: "Four wildly different wire shapes — repo files, ADF issues, XHTML pages, chat history." },
  { scene: "shapes", fromSec: 6, holdSec: 6.5, caption: "Each provider normalizes its mess into one SyncDocument, and tags content_type so chunking knows what to do." },
  { scene: "shapes", fromSec: 13, holdSec: 4.5, caption: "code, markdown, or general — that one field picks the chunking strategy." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 5.5, caption: "The payoff: a new source is one new file plus one line in the registry." },
  { scene: "payoff", fromSec: 6.2, holdSec: 6, caption: "That's exactly how YouTube, Google Drive and Gmail got added — seven providers now, same contract." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "One interface, one registry, one provider-agnostic pipeline. The mess stays inside each provider." },
  { scene: "outro", fromSec: 6, holdSec: 4, caption: "Next: the full product — an enterprise knowledge base I built solo in two months." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
